import { render, staticRenderFns } from "./logisticRegression.vue?vue&type=template&id=6ef1f939&scoped=true"
import script from "./logisticRegression.vue?vue&type=script&lang=js"
export * from "./logisticRegression.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef1f939",
  null
  
)

export default component.exports